import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contactData: {},
};

export const contactDataSlice = createSlice({
  name: "contactData",
  initialState,
  reducers: {
    storeContactData: (state, action) => {
      state.contactData = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { storeContactData } = contactDataSlice.actions;

export default contactDataSlice.reducer;
